/* global importName: false */
import { getDeepProperty } from '@/helpers/deepObject.js'
import hostReadRoutes from './host-read'
import episodeRoutes from './episodes'
import settingsRoutes from './settings'
import audienceRoutes from './audience'
import sitesRoutes from './sites'
import store from '@/services/store'
import accountUtility from '@/services/utilities/accounts.js'

const CreateShow = () => importName('@/scenes/Shows/scenes/NewShow/scenes/Create/Create.vue', 'createShow')
const Dashboard = () => importName('@/scenes/Overview/Dashboard.vue', 'dashboard')
const Delete = () => importName('@/scenes/Shows/scenes/Delete/Delete.vue', 'deleteShow')
const ImportingShow = () => importName('@/scenes/Shows/scenes/NewShow/scenes/Import/scenes/Success.vue', 'importSuccess')
const ImportShow = () => importName('@/scenes/Shows/scenes/NewShow/scenes/Import/Import.vue', 'importShow')
const NewShow = () => importName('@/scenes/Shows/scenes/NewShow/NewShow.vue', 'newShow')
const PreviewShow = () => importName('@/scenes/Shows/scenes/NewShow/scenes/Create/scenes/Preview.vue', 'previewShow')
const SettingsLayout = () => importName('@/scenes/Shows/scenes/Settings/components/SettingsLayout.vue', 'showSettingsLayout')
const ShowLayout = () => importName('@/scenes/Shows/ShowLayout.vue', 'showLayout')
const ShowList = () => importName('@/scenes/Shows/scenes/AccountShowList/ShowListLayout.vue', 'showList')
const ShowSuccess = () => importName('@/scenes/Shows/scenes/NewShow/scenes/Create/scenes/Success.vue', 'createSuccess')
const VerifyShow = () => importName('@/scenes/Shows/scenes/NewShow/scenes/Import/scenes/Verify.vue', 'verifyShow')

const showRoutes = [
  {
    path: 'shows',
    component: ShowLayout,
    children: [
      {
        path: '',
        name: 'all-shows',
        component: ShowList,
        meta: {
          breadcrumbs: [
            { title: 'All Shows' }
          ]
        }
      },
      {
        path: 'create',
        name: 'create-show',
        component: CreateShow
      },
      {
        path: 'create/preview',
        name: 'preview-show',
        component: PreviewShow
      },
      {
        path: 'import',
        name: 'import-show',
        component: ImportShow
      },
      {
        path: 'new',
        name: 'new-show',
        component: NewShow
      },
      {
        path: ':podcastId',
        component: SettingsLayout,
        children: [
          {
            path: '',
            name: 'show-overview',
            component: Dashboard,
            props: true,
            meta: {
              breadcrumbs: [
                { title: 'Shows', to: 'all-shows' },
                // show title will be inserted here by the component
                { title: 'Dashboard' }
              ]
            }
          },
          {
            path: 'delete',
            name: 'delete-show',
            component: Delete,
            props: true
          },
          {
            path: 'success',
            name: 'show-success',
            component: ShowSuccess,
            props: true
          },
          {
            path: 'import/verify',
            name: 'verify-show',
            component: VerifyShow
          },
          {
            path: 'import/success',
            name: 'show-importing',
            component: ImportingShow
          },
          ...settingsRoutes,
          ...sitesRoutes,
          ...episodeRoutes,
          ...hostReadRoutes,
          ...audienceRoutes
        ],
        beforeEnter: async (to, from, next) => {
          // activePodcast loading will already be handled by the time we get here.
          // If it doesn't exist we can safely redirect to Overview so that the system
          // can grab whatever podcast we have access to
          const activePodcast = store.getters.activePodcast
          const accounts = store.getters.accounts
          const defaultAccount = store.getters.defaultAccount
          const activePodcastId = getDeepProperty(activePodcast, 'id')
          const currentAccountId = getDeepProperty(to, 'params.accountId')
          const podcastAccountId = accountUtility.getPodcastAccountUI(activePodcast, accounts, defaultAccount)
          if (!activePodcastId) {
            next({
              name: 'overview'
            })
            return
          }

          // handles case where current account id doesn't match podcast account Id
          if (currentAccountId !== podcastAccountId) {
            next({
              name: to.name,
              params: {
                podcastId: activePodcast.id,
                accountId: podcastAccountId
              }
            })
            return
          }

          // Handle a few cases that we don't want to allow because the show isn't ready yet
          if (to.name !== 'verify-show' && activePodcast.status && activePodcast.status === 'pending' && !activePodcast.is_migration) {
            next({name: 'verify-show', params: {podcastId: activePodcast.id, accountId: podcastAccountId}})
            return
          } else if (to.name !== 'show-importing' && activePodcast.import && activePodcast.import.request && activePodcast.import.request.status !== 'pending') {
            next({name: 'show-importing', params: {podcastId: activePodcast.id, accountId: podcastAccountId}})
            return
          }

          next()
        }
      }
    ]
  }
]

export default showRoutes
